import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import { IRatingsApi, IRequestStatus } from '@/api/ratings/ratings.types';
import {
  IGetCexRatingsResponse,
  IGetCustodyRatingsResponse,
  IGetDefiRatingsResponse,
  IGetEtfRatingsResponse,
  IGetDatRatingsResponse,
  IGetHistoricalCustodyRatings,
  IGetHistoricalEtfRatings,
  IGetLiquidityProviderRatingsResponse,
  IGetStablecoinRatingsResponse,
} from '@/types/ratings';

export class RatingsApi implements IRatingsApi {
  private getBaseUrl(): string {
    return ApiEndpoints.RATINGS;
  }

  constructor(private readonly httpClient: IHttpClient) {}

  getRatings() {
    return this.httpClient.get<IGetCexRatingsResponse>(`${this.getBaseUrl()}exchanges/`);
  }

  getLiquidityProviderRatings() {
    return this.httpClient.get<IGetLiquidityProviderRatingsResponse>(
      `${this.getBaseUrl()}liquidity_providers/`,
    );
  }

  getCustodyRatings() {
    return this.httpClient.get<IGetCustodyRatingsResponse>(`${this.getBaseUrl()}ccr/`);
  }

  getEtfRatings() {
    return this.httpClient.get<IGetEtfRatingsResponse>(`${this.getBaseUrl()}etfs/`);
  }

  getStablecoinRatings() {
    return this.httpClient.get<IGetStablecoinRatingsResponse>(`${this.getBaseUrl()}stable_coins/`);
  }

  getDefiRatings() {
    return this.httpClient.get<IGetDefiRatingsResponse>(`${this.getBaseUrl()}defis/`);
  }

  getDatRatings() {
    return this.httpClient.get<IGetDatRatingsResponse>(`${this.getBaseUrl()}dats/`);
  }

  getExchangesRatingsFile() {
    return this.httpClient.get<string>(`${this.getBaseUrl()}exchanges/get_ratings_file/`);
  }

  getLiquidityProvidersRatingsFile() {
    return this.httpClient.get<string>(`${this.getBaseUrl()}liquidity_providers/get_ratings_file/`);
  }

  getCustodiansRatingsFile() {
    return this.httpClient.get<string>(`${this.getBaseUrl()}ccr/get_ratings_file/`);
  }

  getCustodiansHistoricalRatings() {
    return this.httpClient.get<IGetHistoricalCustodyRatings[]>(
      `${this.getBaseUrl()}ccr/historical/`,
    );
  }

  getEtfHistoricalRatings() {
    return this.httpClient.get<IGetHistoricalEtfRatings[]>(`${this.getBaseUrl()}etfs/historical/`);
  }

  requestStablecoinReport(agioId: string) {
    return this.httpClient.post<void, IRequestStatus>(
      `${this.getBaseUrl()}stable_coins/${agioId}/request_report/`,
    );
  }

  requestEtfReport(agioId: string) {
    return this.httpClient.post<void, IRequestStatus>(
      `${this.getBaseUrl()}etfs/${agioId}/request_report/`,
    );
  }

  requestDatReport(agioId: string) {
    return this.httpClient.post<void, IRequestStatus>(
      `${this.getBaseUrl()}dats/${agioId}/request_report/`,
    );
  }
}
